// extracted by mini-css-extract-plugin
export var aircallIframe = "_fn-3";
export var fabContainer = "_fn-5";
export var fabRinging = "_fn-6";
export var loadingOverlay = "_fn-4";
export var pulse = "_fn-7";
export var widgetContent = "_fn-2";
export var widgetPanel = "_fn-0";
export var widgetPanelExpanded = "_fn-1";